export default "__VITE_ASSET__CfLU73As__"